var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "ma-n4"
  }, [_vm._l(_vm.interviewers, function (item) {
    return [_c('v-col', {
      key: item._id,
      staticClass: "pa-4",
      attrs: {
        "cols": "12"
      }
    }, [_c('room-participants-item', _vm._b({
      attrs: {
        "isItemInterviewer": ""
      }
    }, 'room-participants-item', {
      item
    }, false))], 1)];
  }), _vm._l(_vm.interviewees, function (item) {
    return [_c('v-col', {
      key: item._id,
      staticClass: "pa-4",
      attrs: {
        "cols": "12"
      }
    }, [_c('room-participants-item', _vm._b({}, 'room-participants-item', {
      item
    }, false))], 1)];
  }), _vm.isUserInterviewer ? _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('room-participants-push', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-card', _vm._g(_vm._b({
          staticClass: "pa-8 d-flex justify-center",
          attrs: {
            "flat": "",
            "color": "grey lighten-5"
          }
        }, 'v-card', attrs, false), on), [_c('v-icon', [_vm._v("mdi-plus-circle")])], 1)];
      }
    }], null, false, 3683416201)
  })], 1) : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }